import React from 'react';
import FeedMachineStatusScreen from './screens/FeedMachineStatusScreen';

export default function FeedMachineStatus() {
  return <FeedMachineStatusScreen />;
}
